import React from 'react';

export const MenuSkeleton: React.FC = () => {
  return (
    <div className="space-y-2 py-2">
      {/* Skeleton per 6 elementi del menu */}
      {Array.from({ length: 6 }).map((_, index) => (
        <div key={index} className="animate-pulse">
          <div className="flex items-center px-3 py-2.5">
            {/* Skeleton per l'icona */}
            <div className="w-5 h-5 bg-black/10 rounded mr-3 flex-shrink-0"></div>
            {/* Skeleton per il testo */}
            <div className="h-4 bg-black/10 rounded flex-1"></div>
          </div>
        </div>
      ))}
    </div>
  );
};